module.exports = __webpack_public_path__ + "img/user.6c173660.svg";